<template>
    <div class="sheet_top_overlay" v-if="isShow" :style="styleString" v-clickoutside:action_ClickOutside="{}">
        <span class="title">{{ $t('reservationwindow.reservationmonitor.action_manage_staff_title') }}</span>
        <button @click="action_MoveLeft" :disabled="!canLeft">
            <v-icon>mdi-chevron-left</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_left') }}
        </button>
        <button @click="action_MoveLeftEnd" :disabled="!canLeft">
            <v-icon>mdi-chevron-double-left</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_start') }}
        </button>
        <button @click="action_MoveRight" :disabled="!canRight">
            <v-icon>mdi-chevron-right</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_right') }}
        </button>
        <button @click="action_MoveRightEnd" :disabled="!canRight">
            <v-icon>mdi-chevron-double-right</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_end') }}
        </button>
        <hr>
        <button @click="action_Setting">
            <v-icon>mdi-cog</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_edit_settings') }}
        </button>
        <button @click="action_Default" style="text-align: left;">
            <v-icon>mdi-restore</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_restore_default') }}
        </button>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetState } from '../../../sheet-state'
import { hideColumnMenu, sheetOverlays, showAIDetailEditPopup, showColumnSetting } from '../../../sheet-overlays'
import { sheetFilters, saveColumns } from '../../../sheet-filters'

export default {
    data() {
        return {
            sheetState,
            sheetOverlays,
            sheetFilters,
            position: { top: 0, left: 0 }
        }
    },
    watch: {
        mousePosition: {
            deep: true,
            handler: function (newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.updateFrame()
                    })
                }
            }
        },
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowColumnMenu
        },
        mousePosition: function () {
            return this.sheetOverlays.columnMenuPosition ?? { x: 0, y: 0 }
        },
        styleString: function () {
            // 하다희 - Z-index 값 결정해주세요
            return 'top: ' + this.position.top + 'px;' + ' left: ' + this.position.left + 'px;' + 'z-index: 999;'
        },
        column: function () {
            return {
                _id: this.sheetOverlays.selectedColumn._id,
                isSelected: this.sheetOverlays.selectedColumn.isSelected,
                groupID: this.sheetOverlays.selectedColumn.groupID,
                order: this.sheetOverlays.selectedColumn.order
            }
        },
        canLeft: function () {
            let array = this.sheetFilters.columns.filter(c => c.groupID == this.column.groupID)
            for (let i = 0; i < array.length; i++) {
                if (array[i].order < this.column.order && array[i].isSelected == true) { return true }
            }
            return false
        },
        canRight: function () {
            let array = this.sheetFilters.columns.filter(c => c.groupID == this.column.groupID)
            for (let i = 0; i < array.length; i++) {
                if (array[i].order > this.column.order && array[i].isSelected == true) { return true }
            }
            return false
        }
    },
    methods: {
        action_MoveLeft() {
            this.moveToLeft(this.column)
            hideColumnMenu()
        },
        action_MoveLeftEnd() {
            this.moveToLeftEnd(this.column)
            hideColumnMenu()
        },
        action_MoveRight() {
            this.moveToRight(this.column)
            hideColumnMenu()
        },
        action_MoveRightEnd() {
            this.moveToRightEnd(this.column)
            hideColumnMenu()
        },
        action_Setting() {
            const group = deepCopy(this.sheetFilters.groups)
                .find(g => g._id === this.column.groupID)
            if (group?.isAi) {
                showAIDetailEditPopup(this.sheetOverlays.selectedColumn)
            } else {
                showColumnSetting(this.sheetOverlays.selectedColumn, undefined)
            }
            hideColumnMenu()
        },
        action_Default() {
            this.moveToDefault()
            hideColumnMenu()
        },
        action_ClickOutside() {
            hideColumnMenu()
        },
        // MARK: - Private
        updateFrame() {
            let target = this.$el
            if (!target) {
                this.position = { top: this.mousePosition.y, left: this.mousePosition.x }
            } else {
                let { scrollWidth } = this.sheetState.sheetScrollElement
                let left = (this.mousePosition.x + target.offsetWidth > scrollWidth)
                    ? (this.mousePosition.x - target.offsetWidth)
                    : this.mousePosition.x

                this.position = { top: this.mousePosition.y, left }
            }
        },
        // MARK: - Move, reindex
        getOrderedColumns(groupID) {
            let originColumnArray = deepCopy(this.sheetFilters.columns)
            let array = originColumnArray.filter(c => c.groupID == groupID)
            array = array.map((c) => {
                return {
                    _id: c._id,
                    isSelected: c.isSelected,
                    groupID: c.groupID,
                    order: c.order
                }
            })
            array = array.sort((l, r) => {
                return l.order - r.order
            })
            return array
        },
        moveToDefault() {
            let array = this.sheetFilters.columns.filter(c => this.column.groupID == c.groupID)
            array.sort((l, r) => {
                return l.sortNum - r.sortNum
            })
            array.forEach((c, index) => c.order = index)
            this.updateColumns(array)
        },
        moveToLeft(column) {
            // new array format
            let originColumnArray = this.sheetFilters.columns.filter(c => c.groupID == this.column.groupID)
            let array = this.getOrderedColumns(column.groupID)

            // switch position
            let target = array.find(c => c._id == column._id)
            let originIndex = array.indexOf(target)
            let targetIndex = originIndex - 1
            if (targetIndex < 0) { targetIndex = 0 }
            while (targetIndex >= 0 && originColumnArray[targetIndex].isSelected == false) {
                targetIndex = targetIndex - 1
                if (targetIndex <= 0) { targetIndex = 0 }
            }
            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, column)

            // update
            this.updateColumns(array)
        },
        moveToLeftEnd(column) {
            // new array format
            let array = this.getOrderedColumns(column.groupID)

            // switch position
            let target = array.find(c => c._id == column._id)
            let originIndex = array.indexOf(target)
            let targetIndex = 0
            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, column)

            // update
            this.updateColumns(array)
        },
        moveToRight(column) {
            // new array format
            let originColumnArray = this.sheetFilters.columns.filter(c => c.groupID == this.column.groupID)
            let array = this.getOrderedColumns(column.groupID)

            // switch position
            let target = array.find(c => c._id == column._id)
            let originIndex = array.indexOf(target)
            let targetIndex = originIndex + 1
            let length = array.length - 1
            if (targetIndex > length) { targetIndex = length }
            while (targetIndex >= length && originColumnArray[targetIndex].isSelected == false) {
                targetIndex = targetIndex + 1
                if (targetIndex >= length) { targetIndex = length }
            }
            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, column)

            // update
            this.updateColumns(array)
        },
        moveToRightEnd(column) {
            // new array format
            let array = this.getOrderedColumns(column.groupID)

            // switch position
            let target = array.find(c => c._id == column._id)
            let originIndex = array.indexOf(target)
            let length = array.length - 1
            let targetIndex = length
            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, column)

            // update
            this.updateColumns(array)
        },
        updateColumns(array) {
            array.forEach((c, index) => c.order = index)
            let data = {
                hospitalID: this.hospital.selectedHospital._id,
                columns: array
            }
            saveColumns(data)
        }
    }
}
</script>